<template lang="pug">
include ../assets/html/works-items.pug

.works
  .works__wrap
    .works__header
      .works__header-title Works
      .works__header-close
        router-link(
          to='/'
          @click.native="toHome()"
          )
          .works__header-close-line1
          .works__header-close-line2
    .works__body
      .works__body-items

        - for (let i = 0; i < items.length; i++)
          if (items[i]['public'])
            .works__body-item
              a(
                href=`${items[i]['path']}`
                target="_blank"
                )
                .works__body-item-img
                  img(src=`${items[i]['img']}` alt=`${items[i]['title']}`)
                .works__body-item-date #{items[i]['date']}
                .works__body-item-title
                  !=items[i]['title']
              if (items[i]['info'])
                .works__body-item-info
                  - for (let j = 0; j < items[i]['info'].length; j++)
                      .works__body-item-info-item
                        .works__body-item-info-item-head #{items[i]['info'][j]['head']}
                        a(href=`${items[i]['info'][j]['body']['link']}` target='_blank')
                          | #{items[i]['info'][j]['body']['text']}
</template>

<script>
export default {
  name: "Works",
  mounted: function() {
    this.$store.dispatch("changePage", {
      page: "works"
    });
  },
  methods: {
    toHome: function() {
      this.$store.dispatch("changePage", {
        page: "home"
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/css/foundation/_mixin";

.works {
  position: absolute;
  left: 30px;
  top: 30px;
  padding-bottom: 30px;
  width: calc(100% - 60px);
  min-height: calc(100vh - 60px);
  z-index: 100;
  @include l-mobile {
    left: 15px;
    top: 15px;
    width: calc(100% - 30px);
    min-height: calc(100vh - 30px);
  }
  &__wrap {
    min-height: calc(100vh - 60px);
    background-color: rgba(255, 255, 255, 0.6);
    @include l-mobile {
      min-height: calc(100vh - 30px);
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
  &__header {
    height: 123px;
    @include l-mobile {
      height: 93px;
    }
    &-title {
      padding-top: 26px;
      font-size: 32px;
      letter-spacing: 0.2em;
      color: #000;
      text-align: center;
      @include l-mobile {
        padding-top: 22px;
      }
    }
    &-close {
      position: absolute;
      right: 15px;
      top: 15px;
      & a {
        display: block;
        width: 60px;
        height: 60px;
        @include l-mobile {
          width: 45px;
          height: 45px;
        }
      }
      &-line1 {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -30px;
        margin-top: -1px;
        width: 60px;
        height: 2px;
        background-color: #000;
        transform: rotate(45deg);
        @include l-mobile {
          margin-left: -22px;
          width: 44px;
        }
      }
      &-line2 {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -30px;
        margin-top: -1px;
        width: 60px;
        height: 2px;
        background-color: #000;
        transform: rotate(-45deg);
        @include l-mobile {
          margin-left: -22px;
          width: 44px;
        }
      }
    }
  }
  &__body {
    padding-right: 15px;
    padding-bottom: 90px;
    padding-left: 15px;
    @include l-mobile {
      padding-bottom: 57px;
    }
    &-items {
      display: flex;
      flex-wrap: wrap;
      @include l-mobile {
        justify-content: space-between;
      }
    }
    &-item {
      margin-top: 60px;
      margin-left: 3.5%;
      width: 31%;
      @include l-mobile {
        margin-top: 30px;
        margin-left: 0;
        width: 48%;
      }
      &:nth-child(3n - 2) {
        margin-left: 0;
      }
      & a,
      & span {
        color: #000;
        text-decoration: none;
      }
      &-img {
        width: 100%;
        & img {
          width: 100%;
        }
      }
      &-date {
        margin-top: 15px;
        font-size: 16px;
        letter-spacing: 0.1em;
        @include l-mobile {
          font-size: 12px;
        }
      }
      &-title {
        margin-top: 8px;
        font-size: 20px;
        letter-spacing: 0.1em;
        @include l-mobile {
          font-size: 16px;
        }
      }
      &-info {
        margin-top: 15px;
        &-item {
          display: flex;
          &-head {
            margin-right: 6px;
            font-size: 14px;
            color: #000;
            @include l-mobile {
              font-size: 12px;
            }
          }
          & a {
            font-size: 14px;
            text-decoration: underline;
            @include l-mobile {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}

//
//
//
.works__header-close a {
  transition: opacity 0.2s ease-out 0s;
  .works__header-close-line1,
  .works__header-close-line2 {
    transition: background-color 0.2s ease-out 0s;
  }
}

@include l-more-than-mobile {
  .works__header-close a:hover {
    opacity: 0.6;
    .works__header-close-line1,
    .works__header-close-line2 {
      background-color: #0b2560;
    }
  }
}

.works__body-item a[href^="#"] {
  pointer-events: none;
}

.works__body-item a {
  & .works__body-item-img {
    overflow: hidden;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #0b2560;
      opacity: 0.4;
      transform: scaleY(0);
      transform-origin: center bottom;
      transition: transform 0.2s $easeOutQuart 0s;
    }
  }
  & .works__body-item-da & .works__body-item-title {
    transition: color 0.2s ease-out 0s, opacity 0.2s ease-out 0s;
  }
}

@include l-more-than-mobile {
  .works__body-item a:hover {
    & .works__body-item-img {
      &::after {
        transform: scaleY(1);
      }
    }
    & .works__body-item-date,
    & .works__body-item-title {
      color: #0b2560;
      opacity: 0.6;
    }
  }
}

@include l-more-than-mobile {
  .works__body-item-info-item a:hover {
    text-decoration: none;
  }
}
</style>
